/*
 * Copyright (c) 2022. American Express Company
 */

// theirs
import React, { Component, ReactComponentElement } from 'react';
// ours
import Typography from '../typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import { GlyphRight } from '@americanexpress/dls-react';
// styles and icons
import styles from './ActionCard.module.scss';
import { ActionCardViewModel } from 'src/types/view-models/action-card.view.model';

export default class ActionCard extends Component<ActionCardViewModel> {
    public override render(): ReactComponentElement<any> {
        return (
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            <div onClick={this.props.onClick} className={this.getClasses()}>
                <div className={styles.actionCardTopRow}>
                    <div className={styles.topLeftColumn}>{this.props.children}</div>
                </div>
                <div className={styles.actionDivider}>
                    <hr />
                </div>
                <div className={styles.actionCardBottomRow}>
                    <Typography variant={TypographyVariants.BODY} className={styles.actionText}>
                        {this.props.ctaText}
                    </Typography>
                    <GlyphRight className={styles.actionGlyph} />
                </div>
            </div>
        );
    }

    // get CSS classes
    private getClasses(): string {
        const classes: string[] = [];

        if (this.props.className) {
            classes.push(this.props.className);
        }

        classes.push(styles.actionCard);

        return classes.join(' ');
    }
}
